// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"dc4e0bed","95":"86c649eb","144":"88a12cdf","204":"4d2be3c6","453":"84dbefa2","460":"6203a82c","574":"c8ba9e53","677":"1cc25d00","984":"788f5919"}[chunkId] + ".chunk.js";
};